<div [id]="idModal" class="modal fade modal-filter" aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">
                    Pesquisar Item
                </h4>        
            </div>
            <div class="modal-body" #modalBody>
                <div class="row">
                    <div class="col-12">
                        <table class="table table-striped table-hover" [id]="idDataTable">
                            <thead>
                                <tr>
                                    <th class="col-codigo">Código</th>
                                    <th class="col-nome">Nome</th>
                                    <th class="col-situacao text-center">Situação</th>
                                    <th class="col-data-ultimo-faturamento text-center" *ngIf="exibirDataUltimoFaturamento">Último Faturamento</th>
                                </tr>
                            </thead>
                        </table>                     
                    </div>
                </div>                
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-light" (click)="close()">
                    Cancelar
                </button>
            </div>            
        </div>
    </div>
</div>